<script lang="ts">
    import {Question} from "../../models/Question";
    import {ControlType} from "../../models/ControlType";
    import YesNoQuestion from "../controls/YesNoQuestion.svelte";
    import QuestionDropdown from "../controls/QuestionDropdown.svelte";
    import {createEventDispatcher} from "svelte";
    import QuestionHeader from "../controls/QuestionHeader.svelte";
    import {medicalQuestionsCompleted} from "../../services/NavigationService";

    export let questions: Question[] = [];
    export let pageNumber: Number;
    export let pageTitle: String;
    export let displayButtons: Boolean;
    export let continueToNextPage: Boolean = false;
    export let continueToNextStep: Boolean = false;
    export let continueToNextStepEligible: Boolean = false;
    let continueButtonText = 'Continue';

    const dispatch = createEventDispatcher();

    let pageQuestions: Question[] = [];

    $: if (questions.length > 0) {
        pageQuestions = questions;
    }

    $: if (continueToNextStep && continueToNextStepEligible) {
        continueButtonText = 'Next';
    }


    const backButtonClicked = (event) => {
        event.preventDefault();
        dispatch('pageBackButtonClicked', {
            pageNumber: pageNumber
        })
    }
    const continueButtonClicked = (event) => {
        event.preventDefault();
        dispatch('pageContinueButtonClicked', {
            pageNumber: pageNumber
        });
    }

    const continueToNextStepClicked = (event) => {
        event.preventDefault();
        window.scrollTo(0,0);
        medicalQuestionsCompleted();
    }
</script>

<div class="question-page">
    <h3>Page {pageNumber}</h3>
    <ul>
        {#each pageQuestions as question}
            <li>
                {#if question.controlType === ControlType.YesNo}
                    <YesNoQuestion question={question} />
                {:else if question.controlType === ControlType.DropDown}
                    <QuestionDropdown question={question} />
                    {:else if question.controlType === ControlType.Header}
                    <QuestionHeader question={question} />
                {/if}
                <hr class="lightHr" />
            </li>
        {/each}
    </ul>
    {#if displayButtons}
        <div class="action-button-container">
            {#if pageNumber > 1}
                <button class="pl-cta-primary" on:click={backButtonClicked} style="margin-right: 10px;">Back</button>
            {/if}
            {#if continueToNextPage}
                <button class="pl-cta-primary" on:click={continueButtonClicked}>{continueButtonText}</button>
            {/if}

            {#if continueToNextStep}
                <button class="pl-cta-primary" on:click={continueToNextStepClicked}>Continue To Next Step</button>
                {/if}
        </div>
    {/if}
</div>

<style lang="scss">
    @use "../../../component_scss_library/colors" as colors;
    @use "../../../component_scss_library/buttons" as buttons;
    .question-page {
      ul {
        list-style: none;
        li {
          text-align: left;
          padding: 10px 0;
          margin-bottom: 20px;
        }
      }
    }

    hr.lightHr {
      border: 1px solid colors.$border-color;
    }
</style>

